export interface GGLDataType {
  id: number;
  yearMonth: string | undefined | null;
  lessonTitle: string | undefined | null;
  capLevel: string | undefined | null;
  vimeoId: string | undefined | null;
  vimeoUrl: string | undefined | null;
}

export interface DataType {
  id: string;
  type: string | undefined | null;
  yearMonth: string | undefined | null;
  capLevel: string | undefined | null;
  vimeoId: string | undefined | null;
  fileNameHK: string | null | undefined;
  fileNameKR: string | null | undefined;
  fileNameTW: string | null | undefined;
  fileNamePoster: string | null | undefined;
  seq: number[];
  createTime: string | null | undefined;
}

export interface TEV2DataType {
  seq?: number | undefined | null;
  year: number;
  month: number;
  tev2Banner: string | undefined | null;
  introductionBanner: string | undefined | null;
  vimeoId: string | undefined | null;
  tev2SongId: string | undefined | null;
}

export interface RadioOption {
  label: string;
  value: string;
};

export enum MainType {
  ggla = "GGLA",
  capk = "CAPK",
  fafu = "FAFU",
  plyt = "PLYT",
}
